/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReferredEntityChange = {
    None: 'None',
    Updated: 'Updated',
    Deleted: 'Deleted',
    NotAvailable: 'NotAvailable'
} as const;
export type ReferredEntityChange = typeof ReferredEntityChange[keyof typeof ReferredEntityChange];


export function ReferredEntityChangeFromJSON(json: any): ReferredEntityChange {
    return ReferredEntityChangeFromJSONTyped(json, false);
}

export function ReferredEntityChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredEntityChange {
    return json as ReferredEntityChange;
}

export function ReferredEntityChangeToJSON(value?: ReferredEntityChange | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ReferredEntityChange interface.
 */
 export function instanceOfReferredEntityChange(value: any): value is ReferredEntityChange {
    return Object.values(ReferredEntityChange).includes(value)
}

